export const CLIENT_ID = "37ngj51uyuy8z6l7t3bsd2f736o6za";
export const SCOPES = "user:read:email";

export const STATE_ITEM = "state";
export const TOKEN_ITEM = "token";
